'use client';

let imageOptimizationApiFromCore = null;

try {
  if (typeof require === 'function') {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const coreImageModule = require('@eliadmin/core/next-images-optimization-api-url');
    imageOptimizationApiFromCore = coreImageModule.IMAGE_OPTIMIZATION_API_FROM_CORE;
  }
} catch (error) {
  if (error?.code !== 'MODULE_NOT_FOUND') {
    // eslint-disable-next-line no-console
    console.error('Failed to load @eliadmin/core/next-images-optimization-api-url:', error);
  }

  imageOptimizationApiFromCore = null;
}

export default function myImageLoader({ src, width, quality }) {
  const isLocal = !src.startsWith('http');
  const query = new URLSearchParams();

  // This verified mobile hero is photographic: q90 adds substantial bytes.
  // Match its versioned URL exactly so CMS replacements and other images keep
  // their requested quality. Preload and img srcset share this same loader.
  const isMobileHero =
    src ===
    'https://api.oliout.sk/files/oliout-hlavny-banner-mobile-yUdNM1RMIjg6wReStcjqQUlfH34pro4AksoI1ePa.png?ai=0';
  const imageQuality = isMobileHero ? Math.min(quality ?? 75, 75) : quality;

  const imageOptimizationApi =
    process.env.IMAGE_OPTIMIZATION_API ??
    imageOptimizationApiFromCore ??
    'https://eliadmin.b-cdn.net/image';

  const baseUrl = process.env.NEXT_PUBLIC_APP_URL ?? '';
  const fullSrc = `${baseUrl}${src}`;

  if (width) query.set('width', String(width));
  if (imageQuality) query.set('quality', String(imageQuality));

  if (isLocal && process.env.NODE_ENV === 'development') {
    return src;
  }

  const appendQuery = (url, params) => {
    const serialized = params.toString();
    if (!serialized) return url;

    return `${url}${url.includes('?') ? '&' : '?'}${serialized}`;
  };

  if (isLocal) {
    return appendQuery(`${imageOptimizationApi}/${fullSrc}`, query);
  }

  return appendQuery(`${imageOptimizationApi}/${src}`, query);
}

